// // TimelineScroll.jsx

// import React, { useRef, useEffect, useState } from "react";
// import { useInView } from "framer-motion";
// import { motion } from "framer-motion";
// import founder1 from "../assets/founder1.png";
// import founder2 from "../assets/founder2.png";
// import badge1 from "../assets/timelinebadge1.png";
// import badge2 from "../assets/timelinebadge2.png";
// import milestoneImage from "../assets/milestone.png";     // 🎯 Main illustration
// import emojiStar from "../assets/emoji2.png";             // 🤩 Emoji
// import paperPlane from "../assets/paper-planee.png";      // ✈️ Decoration


// const timelineData = [
//   {
//     id: 1,
//     title: "Lentera is founded",
//     date: "24 May 2019",
//     image: founder1,
//     badge: badge1,
//     description:
//       "Lentera began its journey from a modest apartment in Chennai, driven by a single vision — to build smart, purpose-driven technology that empowers businesses to work better.",
//     direction: "left",
//   },
//   {
//     id: 2,
//     title: "First B2B product launch",
//     date: "24 August 2020",
//     image: founder2,
//     badge: badge2,
//     description:
//       "Lentera launched its first B2B platform, streamlining operations and proving the value of design-first development.",
//     direction: "right",
//   },
// ];

// const TimelineScroll = () => {
//   const lineRef = useRef(null);
//   const [activeIndex, setActiveIndex] = useState(0);

//   const sectionRefs = useRef([]);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             const index = Number(entry.target.dataset.index);
//             setActiveIndex(index);
//           }
//         });
//       },
//       { threshold: 0.5 }
//     );

//     sectionRefs.current.forEach((ref) => {
//       if (ref) observer.observe(ref);
//     });

//     return () => {
//       sectionRefs.current.forEach((ref) => {
//         if (ref) observer.unobserve(ref);
//       });
//     };
//   }, []);

//   return (
//     <>
//     <div className="relative w-full bg-[#f9f9f9] py-24 font-poppins">
//       {/* Center Timeline Vertical Line */}
//       <div className="absolute left-1/2 top-0 h-full w-1 -translate-x-1/2 bg-gray-300 z-0">
//         <div
//           ref={lineRef}
//           className="absolute top-0 left-1/2 w-1 bg-green-500 origin-top transition-all duration-700 ease-in-out"
//           style={{
//             height: `${((activeIndex + 1) / timelineData.length) * 100}%`,
//             transform: `translateX(-50%)`,
//           }}
//         ></div>
//       </div>

//       <div className="flex flex-col gap-40 relative z-10">
//         {timelineData.map((item, index) => {
//           const isLeft = item.direction === "left";
//           return (
//             <div
//               key={item.id}
//               ref={(el) => (sectionRefs.current[index] = el)}
//               data-index={index}
//               className={`relative flex items-center justify-between w-full max-w-6xl mx-auto px-6 lg:px-10 ${
//                 isLeft ? "flex-row" : "flex-row-reverse"
//               }`}
//             >
//               {/* Image Side */}
//               <div className="w-1/2 flex justify-center relative">
//                 <img
//                   src={item.image}
//                   alt={item.title}
//                   className="w-[400px] h-[400px] object-cover rounded-full border-[6px] border-green-300"
//                 />
//                 <img
//                   src={item.badge}
//                   alt="badge"
//                   className={`absolute top-2 ${
//                     isLeft ? "right-2" : "left-2"
//                   } w-28 h-auto`}
//                 />
//               </div>

//               {/* Text Side */}
//               <div className="w-1/2">
//                 <div className="flex items-center gap-3 mb-2">
//                   <div
//                     className={`w-4 h-4 rounded-full border-[3px] border-green-500 transition-all duration-500 ${
//                       activeIndex >= index ? "bg-green-500" : "bg-white"
//                     }`}
//                   />
//                   <h3 className="text-xl font-bold text-gray-900">
//                     {item.title}
//                   </h3>
//                 </div>
//                 <div className="bg-white shadow-md rounded-lg p-5 mt-2">
//                   <p className="text-sm text-gray-500 font-semibold mb-2">
//                     {item.date}
//                   </p>
//                   <p className="text-gray-700 text-base leading-relaxed">
//                     {item.description}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//     <section className="bg-white py-20 px-6 lg:px-20 relative overflow-hidden">
//       <div className="max-w-7xl mx-auto">
//         {/* Heading */}
//         <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
//           Our journey through the years
//         </h2>
//         <p className="text-center text-gray-600 text-lg max-w-3xl mx-auto mb-16">
//           Creating stellar products for our users is always our top priority. We believe it’s not the big wins, but the small, consistent ones — powered by persistence and passion — that truly shape success.
//         </p>

//         {/* Main layout */}
//         <div className="flex flex-col lg:flex-row gap-12 items-center justify-center relative z-10">
//           {/* Left - Image + Quote */}
//           <motion.div
//             className="bg-[#f9f9f9] rounded-3xl shadow-md relative flex flex-col items-center justify-center"
//             style={{ width: "648px", height: "484px", padding: "2rem" }}
//             initial={{ opacity: 0, y: 40 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6 }}
//           >
//              <p className="text-xl weight-[400] height-[28px] font-semibold text-center text-gray-800">
//               Every win is a milestone <br /> and we celebrate it.
//             </p>
//             <img
//               src={milestoneImage}
//               alt="Milestone"
//               className="object-contain w-full h-3/4 mb-4"
//             />
//             <img
//               src={emojiStar}
//               alt="Emoji Star"
//               className="absolute top-6 right-16 w-10 h-10"
//             />
//             </motion.div>

//           {/* Right - Stats */}
//           <motion.div
//             className="bg-[#E4FFEC] rounded-3xl shadow-md grid grid-cols-2 gap-y-8 text-center"
//             style={{ width: "648px", height: "484px", padding: "2rem" }}
//             initial={{ opacity: 0, y: 40 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6, delay: 0.2 }}
//           >
//             {[
//               { number: "6+", label: "Years in Business" },
//               { number: "50+", label: "Expert Teams" },
//               { number: "15+", label: "Products" },
//               { number: "4", label: "Countries Served" },
//               { number: "50K+", label: "Users" },
//               { number: "220+", label: "Projects Completed" },
//             ].map((item, idx) => (
//               <div key={idx} className="flex flex-col items-center">
//                 <p className="text-3xl font-bold text-gray-900">{item.number}</p>
//                 <p className="text-sm text-gray-600 mt-1 w-40">{item.label}</p>
//               </div>
//             ))}
//           </motion.div>
//         </div>
//       </div>

//       {/* Paper plane */}
//       <motion.img
//         src={paperPlane}
//         alt="Paper Plane"
//         className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-28 opacity-70"
//         initial={{ x: -200, y: -50, rotate: -10, opacity: 0 }}
//         animate={{ x: 0, y: 0, rotate: 0, opacity: 0.7 }}
//         transition={{ duration: 1.5, delay: 0.3, ease: "easeOut" }}
//       />
//     </section>
//     </>
//   );
// };

// export default TimelineScroll;

import { motion } from "framer-motion";
import React, { useState, useEffect, useRef } from "react";
import sparkIcon from "../assets/spark-icon.png";
import rocketIcon from "../assets/rocket-icon.png";
import sasikumar from "../assets/sasikumarr.png";
import milestoneImage from "../assets/milestone.png";     // 🎯 Main illustration
import emojiStar from "../assets/emoji2.png";             // 🤩 Emoji
import paperPlane from "../assets/paper-planee.png";      // ✈️ Decoration
import customerImage from "../assets/nicole.png";
import quoteStart from "../assets/quote-start.png";
import quoteEnd from "../assets/quote-end.png";
import leftArrow from "../assets/arrow-left.png";
import rightArrow from "../assets/arrow-right.png";

const TimelineSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = [useRef(null), useRef(null), useRef(null)];

  const images = [
    {
      src: sparkIcon,
      // circleColor: "bg-green-200",
      alt: "Spark Icon",
    },
    {
      src: rocketIcon,
      // circleColor: "bg-pink-200",
      alt: "Rocket Icon",
    },
    {
      src: sasikumar,
      // circleColor: "",
      alt: "Sasi Kumar S",
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const offsets = sectionRefs.map((ref) =>
        ref.current ? ref.current.getBoundingClientRect().top : 9999
      );

      const active = offsets.findIndex((top) => top > window.innerHeight * 0.2);
      setActiveIndex(active === -1 ? 2 : Math.max(0, active - 1));
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // initialize on load

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
const stats = [
    { number: "6+", label: "Years in Business" },
    { number: "50+", label: "Expert Teams" },
    { number: "15+", label: "Products" },
    { number: "4", label: "Countries Served" },
    { number: "50K+", label: "Users" },
    { number: "220+", label: "Projects Completed" },
  ];
  
  return (
    <>
     <section className="w-full bg-[#F8F9FB] py-16 px-6 lg:px-20 text-center font-poppins">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto"
        >
          <h2 className="text-4xl sm:text-6xl font-bold leading-tight mb-4">
            <span className="bg-gradient-to-r from-[#07862B] to-[#FFEE2F] bg-clip-text text-transparent">
              6+
            </span>{" "}
            <span className="bg-gradient-to-r from-[#07862B] to-[#FFEE2F] bg-clip-text text-transparent">years</span>
          </h2>
          <p className="text-gray-800 text-lg sm:text-xl">
            of running a business has taught<br/> us many things
          </p>
        </motion.div>
      </section>

      {/* MAIN TIMELINE SECTION */}
      <section className="w-full bg-white font-poppins py-20 px-6 lg:px-20">
        <div className="flex flex-col lg:flex-row gap-10 relative">
          {/* LEFT STICKY IMAGE DISPLAY */}
          <div className="lg:w-[40%] w-full relative">
            <div className="sticky top-20 flex justify-center items-center h-[400px] md:h-[500px]">
              <div className="relative w-full flex justify-center items-center">
                {images[activeIndex].circleColor && (
                  <div
                    className={`absolute w-48 h-48 md:w-64 md:h-64 ${images[activeIndex].circleColor} rounded-full top-8 left-4 -z-10`}
                  />
                )}
                <img
                  src={images[activeIndex].src}
                  alt={images[activeIndex].alt}
                  className="w-[280px] md:w-[400px] lg:w-[469px] h-auto object-contain drop-shadow-xl"
                />
                {activeIndex === 2 && (
                  <div className="absolute bottom-3 md:bottom-6 left-3 md:left-6 w-[220px] md:w-[260px] bg-white rounded-bl-2xl rounded-br-2xl border-t border-gray-300 px-3 md:px-4 py-2 md:py-3 shadow-sm">
                    <h3 className="text-center text-sm md:text-base font-semibold text-gray-900 leading-tight">
                      Sasi kumar S
                    </h3>
                    <p className="text-center text-xs md:text-sm text-gray-500">
                      Founder & CEO of Lentera
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* RIGHT TIMELINE CONTENT */}
          <div className="lg:w-[60%] w-full flex flex-col gap-20">
            {/* Block 1 */}
            <div ref={sectionRefs[0]}>
              <h2 className="text-3xl md:text-4xl font-semi text-gray-900 leading-tight mb-6">
                The Spark - Year of <br className="hidden sm:block" />
                Inception (2019)
              </h2>
              <div className="relative bg-yellow-100 px-5 py-4 rounded-md mb-6 text-gray-800 font-medium text-base md:text-lg leading-relaxed">
                <span className="absolute -left-4 -top-3 text-yellow-500 text-3xl md:text-4xl font-serif">
                  &ldquo;
                </span>
                We believe the best software is built by small teams in
                informal, collaborative environments — not by chasing numbers or
                rigid metrics.
                <span className="absolute -right-4 -bottom-3 text-yellow-500 text-3xl md:text-4xl font-serif">
                  &rdquo;
                </span>
              </div>
              <p className="text-gray-700 text-base leading-relaxed mb-4">
                In 2019, inside a modest apartment in suburban Chennai, a bold
                idea was born — build smart technology to help businesses work
                better.
              </p>
              <p className="text-gray-700 text-base leading-relaxed mb-4">
                With limited resources but unlimited determination, Lentera was
                born — not in a boardroom, but at a kitchen table surrounded by
                laptops, whiteboards, and ideas that wouldn’t quit.
              </p>
              <p className="text-gray-700 text-base leading-relaxed">
                This was our beginning — humble, hungry, and human.
              </p>
            </div>

            {/* Block 2 */}
            <div ref={sectionRefs[1]}>
              <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 leading-tight mb-6">
                The original problem we <br className="hidden sm:block" />
                aimed to solve
              </h2>
              <div className="relative bg-yellow-100 px-5 py-4 rounded-md mb-6 text-gray-800 font-medium text-base md:text-lg leading-relaxed">
                <span className="absolute -left-4 -top-3 text-yellow-500 text-3xl md:text-4xl font-serif">
                  &ldquo;
                </span>
                Too many tools. Too little clarity. We knew there had to be a
                smarter way to work.
                <span className="absolute -right-4 -bottom-3 text-yellow-500 text-3xl md:text-4xl font-serif">
                  &rdquo;
                </span>
              </div>
              <p className="text-gray-700 text-base leading-relaxed mb-4">
                Back in 2019, we noticed a common pattern across businesses —
                too many tools, too much complexity, and not enough clarity.
              </p>
              <p className="text-gray-900 font-semibold mb-2">
                That question led to our mission:
              </p>
              <p className="text-gray-700 text-base leading-relaxed">
                To design intelligent digital solutions that solve real business
                challenges — not create new ones.{" "}
                <span className="bg-emerald-100 px-1 italic font-semibold">
                  We didn’t set out to reinvent the wheel. We set out to make it
                  roll smoother.
                </span>
              </p>
            </div>

            {/* Block 3 */}
            <div ref={sectionRefs[2]}>
              <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 leading-tight mb-6">
                Who founded it & started <br className="hidden sm:block" />
                it with great will
              </h2>
              <div className="relative bg-yellow-100 px-5 py-4 mb-6 text-gray-800 font-medium text-base md:text-lg leading-relaxed">
                <span className="absolute -left-4 -top-3 text-yellow-500 text-3xl md:text-4xl font-serif">
                  &ldquo;
                </span>
                we were solving a problem we lived every day. That’s what made
                it real.
                <span className="absolute -right-4 -bottom-3 text-yellow-500 text-3xl md:text-4xl font-serif">
                  &rdquo;
                </span>
              </div>
              <p className="text-gray-700 text-base leading-relaxed mb-4">
                Lentera was born from the grit and vision of a few determined
                individuals who saw possibility where others saw complexity.
              </p>
              <p className="text-gray-700 text-base leading-relaxed mb-4">
                Fueled by purpose and a strong will to make a difference, they
                laid the foundation not just for a company, but for a culture
                rooted in innovation, integrity, and impact.
              </p>
              <p className="text-gray-900 font-semibold">
                That spirit still drives everything we do today.
              </p>
            </div>
          </div>
        </div>
      </section>

 <section className="bg-white py-20 px-4 flex flex-col items-center">
  {/* Heading */}
  <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-[48px] font-semibold text-gray-900 text-center mb-4 leading-tight">
    Our journey through the years
  </h2>

  <p className="text-base sm:text-lg text-gray-600 text-center max-w-3xl mb-14 leading-relaxed px-2">
    Creating stellar products for our users is always our top priority. We believe it's not
    the big wins, but the small, consistent ones — powered by persistence and
    passion — that truly shape success.
  </p>

  {/* Content Block */}
  <div className="flex flex-col lg:flex-row flex-wrap gap-10 w-full max-w-[1296px]">
    {/* Left Side – Milestone Box */}
    <div className="relative w-full lg:w-[48%] aspect-[4/3] rounded-2xl overflow-hidden shadow bg-[#F9F9F9] min-h-[300px]">
      {/* Background Illustration */}
      <img
        src={milestoneImage}
        alt="Milestone Illustration"
        className="absolute bottom-0 w-full h-auto object-contain"
      />

      {/* Emoji in top-right */}
      <img
        src={emojiStar}
        alt="Emoji Star"
        className="absolute top-4 right-4 w-10 h-10 md:w-[56px] md:h-[56px]"
      />

      {/* Centered Text */}
      <div className="absolute top-10 left-0 right-0 z-10 px-4 md:px-8 text-center">
        <h3 className="text-xl sm:text-2xl md:text-[28px] font-semibold text-gray-900 leading-snug">
          Every win is a milestone <br /> and we celebrate it.
        </h3>
      </div>

      {/* Paper Plane in bottom-left */}
      <img
        src={paperPlane}
        alt="Paper Plane"
        className="absolute bottom-[35%] left-3 w-[140px] md:w-[260px] h-auto object-contain"
      />
    </div>

    {/* Right Side – Stats */}
    <div className="w-full lg:w-[48%] bg-[#E9FBED] rounded-2xl flex flex-col min-h-[300px] py-4">
      {[0, 2, 4].map((i, rowIndex) => (
        <div
          key={rowIndex}
          className="flex flex-1 items-center justify-center divide-x divide-gray-300 last:border-b-0"
        >
          {[stats[i], stats[i + 1]].map((item, colIndex) => (
            <div key={colIndex} className="w-1/2 text-center px-4 py-4">
              <div className="text-2xl md:text-[32px] font-semibold text-gray-900">
                {item.number}
              </div>
              <div className="text-xs sm:text-sm text-gray-600 mt-1 uppercase tracking-wide">
                {item.label}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
</section>
<section className="bg-[#F9FAFB] py-20 px-4 flex flex-col items-center">
  {/* Section Title */}
  <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-[48px] font-semibold text-gray-900 text-center mb-4 leading-tight">
    Customer insights & analytics
  </h2>
  <p className="text-base sm:text-lg text-gray-600 text-center max-w-3xl mb-16 leading-relaxed px-2">
    We make smarter decisions by listening to our customers and analyzing their experiences.
    Real feedback and data drive how we improve, adapt, and deliver value.
  </p>

  {/* Testimonial Card with Arrows */}
  <div className="relative flex flex-col lg:flex-row items-center justify-center gap-6 w-full max-w-[1140px] px-4">
    {/* Left Arrow */}
    <button className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white shadow-md flex items-center justify-center hover:scale-105 transition">
      <img src={leftArrow} alt="Left Arrow" className="w-5 h-5 md:w-6 md:h-6" />
    </button>

    {/* Testimonial Card */}
    <div className="w-full flex flex-col md:flex-row bg-white rounded-2xl shadow-lg p-6 md:p-10">
      {/* Left - Customer Info */}
      <div className="w-full md:w-[220px] mb-6 md:mb-0 md:pr-8 md:border-r border-gray-200 flex flex-col items-center justify-center">
        <img
          src={customerImage}
          alt="Customer"
          className="w-[120px] md:w-[160px] h-[120px] md:h-[160px] object-cover rounded-[24px] md:rounded-[32px] mb-4"
        />
        <h3 className="text-base md:text-lg font-semibold text-gray-900">Nicole France</h3>
        <p className="text-sm text-gray-500">Flyjac Logistics Pvt Ltd</p>
        <span className="text-xs mt-2 px-3 py-1 rounded-full bg-green-100 text-green-600 font-medium">
          IT Head
        </span>
      </div>

      {/* Right - Testimonial Content */}
      <div className="flex-1 md:pl-8 flex items-center justify-center">
        <div className="relative bg-[#FFF6DE] rounded-md text-gray-800 text-sm md:text-base leading-relaxed px-6 py-5 max-w-full">
          {/* Quote Start */}
          <img
            src={quoteStart}
            alt="Start Quote"
            className="absolute -top-4 -left-4 w-5 h-5 md:w-[16px] md:h-[31px]"
          />

          {/* Testimonial Text */}
          <p className="relative z-10">
            To succeed as a technology company, you have to stand out from the crowd.
            Innovation requires challenging the mainstream — and Lentera has certainly done that.
          </p>

          {/* Quote End */}
          <img
            src={quoteEnd}
            alt="End Quote"
            className="absolute -bottom-3 -right-3 w-4 h-4 md:w-[16px] md:h-[31px]"
          />
        </div>
      </div>
    </div>

    {/* Right Arrow */}
    <button className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white shadow-md flex items-center justify-center hover:scale-105 transition">
      <img src={rightArrow} alt="Right Arrow" className="w-5 h-5 md:w-6 md:h-6" />
    </button>
  </div>
</section>

    </>
  );
};

export default TimelineSection;
